import {Outlet} from "react-router-dom";
import {useAuth0} from "@auth0/auth0-react";
import {LoadingPage} from "@/pages/LoadingPage.tsx";
import {LoginPage} from "@/pages/LoginPage.tsx";
import {useUserData} from "@/hooks/use-user-data-provider.ts";

export function EnsureLoggedIn() {
  const {isAuthenticated, isLoading,} = useAuth0();
  const me = useUserData()
  
  return (<>
      {isLoading || me.isLoading ? (
        <LoadingPage/>
      ) : isAuthenticated && me.user?.id ? (
        <Outlet/>
      ) : (
        <LoginPage/>
      )}
    </>
  );
}
